<template>
  <div
    class="input-row-phone-number"
    :class="{ 'input-row-phone-number--invalid-country': !phoneHasCountry }"
  >
    <InputSelect
      name="account"
      className="input-row-select--countries"
      v-model="phone_country_code"
      :filter="true"
      :options="countries"
      optionValue="code"
      optionLabel="name"
      label=""
      :hasIconLeft="true"
    >
      <template #displayText>
        <div v-if="phone_country_code" class="country-selection__country">
          <img :alt="phone_country_code as string" :src="`/flags/${phone_country_code}.svg`" />
        </div>
        <div v-else class="country-selection__country">
          <IconMap />
        </div>
      </template>

      <template #optionText="slotProps">
        <div
          class="country-selection__country"
          :class="{ 'country-selection__country-border': slotProps.code === 'us' }"
        >
          <img :alt="slotProps.name" :src="`/flags/${slotProps.code}.svg`" />
          {{ slotProps.name }}
        </div>
      </template>
    </InputSelect>

    <InputText
      name="phone_number"
      v-model="phone_number"
      :label="showLabel ? 'Phone number' : ''"
      :mask="maskCountryCode"
      :placeholder="maskCountryCode !== '' ? maskCountryCode : 'Choose country'"
      @onKeypress="isNumber($event)"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue';

import countries, { type countryType } from '@/data/country-codes';

import InputSelect from './InputSelect.vue';
import InputText from './InputText.vue';

import IconMap from '@/icons/IconMap.svg?component';

const phone_number = defineModel<string>('phone_number');
const phone_country_code = defineModel<countryType | null | string>('phone_country_code');

withDefaults(
  defineProps<{
    showLabel?: boolean;
  }>(),
  {
    showLabel: true,
  },
);

const maskCountryCode = ref<string>('');

if (phone_country_code.value) {
  const country = countries.find((cty) => cty.code === phone_country_code.value);
  if (country) {
    maskCountryCode.value = country.mask;
  }
}

const phoneHasCountry = computed(() => {
  // If we have a phone number but no country code.
  if (phone_number.value !== '' && phone_number.value !== undefined && !phone_country_code.value) {
    return false;
  }
  return true;
});

watch(phone_country_code, (newVal) => {
  const country = countries.find((cty) => cty.code === newVal);
  if (country) {
    maskCountryCode.value = country.mask;
  } else {
    maskCountryCode.value = '';
  }
});

const isNumber = (evt: KeyboardEvent) => {
  if (isNaN(parseInt(evt.key))) {
    evt.preventDefault();
  } else {
    return true;
  }
};
</script>
